import { render, staticRenderFns } from "./pi-select.vue?vue&type=template&id=5bfc1c28&"
import script from "./pi-select.vue?vue&type=script&lang=ts&"
export * from "./pi-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports